import SEOHead from '@/components/SEOHead';
import ContactHeroV2 from '@/components/marketing/contact/v2/ContactHeroV2';
import ContactFormSectionV2 from '@/components/marketing/contact/v2/ContactFormSectionV2';
import ContactChannelsV2 from '@/components/marketing/contact/v2/ContactChannelsV2';
import ContactOfficeV2 from '@/components/marketing/contact/v2/ContactOfficeV2';
import ContactFaqV2 from '@/components/marketing/contact/v2/ContactFaqV2';
import { FinalCtaSection } from '@/components/marketing/v2/FinalCtaSection';

export default function Contact() {
  return (
    <>
      <SEOHead
        title="Contact — Support Velko POS (Yaoundé, Cameroun)"
        description="Contactez l'équipe Velko POS basée à Yaoundé. WhatsApp +237 656 48 88 79, téléphone, email. Réponse sous 24h ouvrables. Une vraie équipe, pas un chatbot."
        path="/contact"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'Contact', path: '/contact' },
        ]}
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'LocalBusiness',
            name: 'Velko POS',
            description: 'Logiciel de caisse pour commerçants africains',
            url: 'https://velko-pos.com',
            telephone: '+237656488879',
            email: 'contact@velko-pos.com',
            address: {
              '@type': 'PostalAddress',
              streetAddress: 'Rond-Point Damas',
              addressLocality: 'Yaoundé',
              addressCountry: 'CM',
            },
            openingHoursSpecification: {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
              opens: '08:00',
              closes: '18:00',
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'Quel est le délai de réponse ?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Moins de 24h ouvrables par email et formulaire. Moins de 30 min sur WhatsApp pendant les heures ouvrées.',
                },
              },
              {
                '@type': 'Question',
                name: 'Puis-je avoir une démo personnalisée ?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: "Oui. Choisissez 'Demande de démo' dans le formulaire — nous prévoyons un appel visio de 30 minutes avec votre catalogue réel.",
                },
              },
              {
                '@type': 'Question',
                name: 'Puis-je appeler directement ?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Oui, du lundi au vendredi de 8h à 18h GMT+1. Un humain décroche aux heures ouvrées.',
                },
              },
              {
                '@type': 'Question',
                name: 'Vous répondez en français partout ?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: "Oui, partout et tout le temps. L'anglais est disponible sur email pour les partenaires institutionnels et la presse.",
                },
              },
            ],
          },
        ]}
      />

      <ContactHeroV2 />
      <ContactFormSectionV2 />
      <ContactChannelsV2 />
      <ContactOfficeV2 />
      <ContactFaqV2 />
      <FinalCtaSection
        eyebrow="Prêt à tester ?"
        title="Essaie Velko gratuitement."
        highlight="Sans carte."
        subtitle="Crée ton compte en 3 minutes, importe ton catalogue, fais ta première vente. Si quelque chose coince, on est là."
        primaryLabel="Créer un compte gratuit"
        primaryTo="/register"
        secondaryLabel="Voir les tarifs"
        secondaryTo="/tarifs"
      />
    </>
  );
}
